// extracted by mini-css-extract-plugin
export default {"loader":"SpinnerButton_loader__bTYLs","relative":"SpinnerButton_relative__A-XVG","hideText":"SpinnerButton_hideText__DHMAY"};